module.exports = __webpack_public_path__ + "img/creditofiscal.a027697b.jpg";